import { render, staticRenderFns } from "./screen-area.vue?vue&type=template&id=ffbd7706&scoped=true"
import script from "./screen-area.vue?vue&type=script&lang=js"
export * from "./screen-area.vue?vue&type=script&lang=js"
import style0 from "./screen-area.vue?vue&type=style&index=0&id=ffbd7706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbd7706",
  null
  
)

export default component.exports